// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll("carousel-navigation.carousel-arrows").forEach(nav => {
//     const carouselId = nav.getAttribute("aria-controls");
//     const carousel = document.getElementById(carouselId);

//     if (!carousel) return;

//     const prevBtn = nav.querySelector(".prev");
//     const nextBtn = nav.querySelector(".next");

//     function getItemWidth() {
//       // Look for one product card inside the cross-sell carousel
//       const item = carousel.querySelector(".product-card-horizontal, .complementary-products__product-list > *");
//       return item ? item.offsetWidth + parseInt(getComputedStyle(item).marginRight) : 200;
//     }

//     prevBtn?.addEventListener("click", () => {
//       carousel.scrollBy({ left: -getItemWidth(), behavior: "smooth" });
//     });

//     nextBtn?.addEventListener("click", () => {
//       carousel.scrollBy({ left: getItemWidth(), behavior: "smooth" });
//     });
//   });
// });

jQuery(".tiktok-slider").owlCarousel({
  autoplay: false,
  lazyLoad: true,
  loop: true,
  margin: 15,
   /*
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  */
  autoplayTimeout: 7000,
  smartSpeed: 300,
  nav: true,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="17.348" height="13.515" viewBox="0 0 17.348 13.515"><path id="Path_1" data-name="Path 1" d="M268,391.033H252.271l5.756,5.75a.373.373,0,1,1-.528.528l-6.38-6.385a.326.326,0,0,1-.046-.057.216.216,0,0,1-.017-.028l-.018-.037-.011-.037a.15.15,0,0,1,0-.031.364.364,0,0,1,0-.144.15.15,0,0,1,0-.031l.011-.037.018-.037a.214.214,0,0,1,.017-.028.325.325,0,0,1,.046-.057l6.38-6.385a.369.369,0,0,1,.522-.006l.006.006a.369.369,0,0,1,0,.522h0l-5.756,5.756H268a.369.369,0,1,1,0,.739Z" transform="translate(-251.019 -383.905)" fill="#030504"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="17.348" height="13.515" viewBox="0 0 17.348 13.515"> <path id="Path_2" data-name="Path 2" d="M251.388,391.033h15.727l-5.756,5.75a.373.373,0,0,0,.528.528l6.38-6.385a.326.326,0,0,0,.046-.057.216.216,0,0,0,.017-.028l.018-.037.011-.037a.15.15,0,0,0,0-.031.364.364,0,0,0,0-.144.15.15,0,0,0,0-.031l-.011-.037-.018-.037a.214.214,0,0,0-.017-.028.325.325,0,0,0-.046-.057l-6.38-6.385a.369.369,0,0,0-.522-.006l-.006.006a.369.369,0,0,0,0,.522h0l5.756,5.756H251.388a.369.369,0,1,0,0,.739Z" transform="translate(-251.019 -383.905)" fill="#030504"/> </svg>',
  ],
  dots: false,
  responsive: {
    0: {
      items: 1,
      margin: 10
    },

    767: {
      items: 2
    },

    991: {
      items: 3
    },

    1200: {
      items: 3
    }
  }
});